
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 1.5V.75zM3.952 6.844h-.75zm2.352 8.162.717-.22zm6.393 0-.718-.22zm5.228-.604.483-.575zm-16.85 0 .482.574zm14.723-7.558c0-1.625-.67-3.178-1.854-4.319l-1.041 1.08a4.5 4.5 0 0 1 1.395 3.24zm-1.854-4.319A6.4 6.4 0 0 0 9.5.75v1.5c1.281 0 2.505.49 3.403 1.356zM9.5.75c-1.662 0-3.26.636-4.444 1.775l1.041 1.08A4.9 4.9 0 0 1 9.5 2.25zM5.056 2.525a6 6 0 0 0-1.854 4.32h1.5c0-1.21.498-2.376 1.395-3.24zm-1.854 4.32c0 4.281-1.745 6.256-2.61 6.982l.965 1.15c1.176-.988 3.145-3.372 3.145-8.133zm15.206 6.982c-.865-.726-2.61-2.7-2.61-6.983h-1.5c0 4.76 1.969 7.145 3.145 8.132zM9.5 18.25c1.381 0 2.332-.602 2.946-1.29a4.8 4.8 0 0 0 .968-1.734l-1.435-.44c-.069.226-.26.735-.653 1.175-.374.42-.937.789-1.826.789zm3.388-2.64h4.891v-1.5h-4.891zm-11.667 0h4.891v-1.5H1.221zm4.365-.384c.1.328.373 1.066.968 1.734.613.688 1.565 1.29 2.946 1.29v-1.5c-.89 0-1.452-.368-1.826-.789a3.3 3.3 0 0 1-.653-1.174zm.526.385a.55.55 0 0 1-.526-.385l1.435-.44a.95.95 0 0 0-.909-.675zm7.302-.385a.55.55 0 0 1-.526.385v-1.5a.95.95 0 0 0-.909.676zm4.03-.25a.49.49 0 0 1-.175-.52.52.52 0 0 1 .51-.345v1.5c.567 0 .842-.452.922-.709.081-.26.102-.743-.293-1.075zM.591 13.827c-.395.332-.374.814-.293 1.075.08.257.355.709.922.709v-1.5c.366 0 .492.286.51.346a.49.49 0 0 1-.174.52zm4.368 1.756h9.08v-1.5H4.96z","fill":"#2a2b2e"}})])
          )
        }
      }
    